import {
  EVENT_TYPES,
  MetrixEventData,
  METRIX_EVENT_TYPES,
} from "../types/analytics-type";

export { EVENT_TYPES, METRIX_EVENT_TYPES };

export function logEvent(type: EVENT_TYPES, data?: any) {
  // @ts-ignore
  let firebase = window.firebase;
  if (!firebase) {
    return;
  }

  return firebase.analytics().logEvent(type, data || {});
}

export function logMetrixEvent(type: string, data: MetrixEventData = {}) {
  // @ts-ignore
  let Metrix = window.Metrix;

  if (!Metrix) {
    return;
  }

  let { isRevenue = false, ...properties } = data;

  if (isRevenue) {
    let { amount, orderId } = properties;
    return Metrix.sendRevenue(type, amount, 0, orderId);
  }

  return Metrix.sendEvent(type, properties);
}
